import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import FileItem, {type File} from './FileItem';

const useStyles = makeStyles(() => ({
  fileGrid: {
    marginTop: '2%',
  },
}), { name: 'FileGrid' });

export type FileGridProps = {
  files: File[];
};

const FileGrid = ({ files }: FileGridProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid alignItems="center" className={classes.fileGrid} container>
      {files.map((file, index) => (
        <FileItem file={file} index={index} key={index} />
      ))}
    </Grid>
  );
};

export default FileGrid;
